export default "__VITE_ASSET__CTs8kado__"